import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import { Option } from "./components/Option";

const OptionList = [
  { name: "Lost a significant amount", value: "LostSignificant" },
  { name: "Lost a little", value: "LostLittle" },
  { name: "About the same", value: "Same" },
  { name: "Gained a little", value: "GainedLittle" },
  { name: "Gained a significant amount", value: "GainedSignificantly" },
];

export const WeightInLastYear = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("WeightInLastYear", value);
    setLastUpdate({ key: "WeightInLastYear", value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <p className="pb-8 font-serif text-h3">
        How has your weight changed in the last 12 months?
      </p>
      <div>
        <div className="flex flex-wrap gap-3" key="WeightLast12">
          {OptionList.map((option) => (
            <Option
              key={option.value}
              name={option.name}
              value={option.value}
              checked={props.data.WeightInLastYear === option.value}
              onChange={(e) => handleChange(option.value)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
